import InformationRow from "../StyledComponents/InformationRow";

function AddressSection({ address }: { address: string }) {
  return <InformationRow title="Adresse" value={address} />;
}

export default AddressSection;
